// src/components/ui/ThemeToggle.jsx
import React from 'react';
import { useTheme } from '../../hooks/useTheme';
import { Moon, Sun } from 'lucide-react';
import styles from '../../styles/ThemeToggle.module.css';

const ThemeToggle = () => {
  const { isDarkMode, toggleTheme } = useTheme();

  return (
    <button 
      onClick={toggleTheme}
      className={`${styles.themeToggle} ${isDarkMode ? styles.themeToggleDark : styles.themeToggleLight}`}
      aria-label={isDarkMode ? 'Switch to light theme' : 'Switch to dark theme'}
    >
      {isDarkMode ? (
        <Sun size={20} />
      ) : (
        <Moon size={20} />
      )}
      <span 
        className={`${styles.hoverEffect} ${isDarkMode ? styles.hoverEffectDark : styles.hoverEffectLight}`}
      />
    </button>
  );
};

export default ThemeToggle;